module.exports = __webpack_public_path__ + "img/2012-12-14 20.14.04.2d0bb869.jpg";